import { Component, Input } from '@angular/core';

import { SuburbCatalogueService } from '../workspace/catalogue.service';
import { changeText, crawlFacts, safeUrl } from './suburb-facts';

/**
 * A suburb's Data tab (#256): what the crawl found there (richness, venues by what they suit, landmarks, images,
 * venues) and the change log of its region, page and sub-regions. Crawl values are untrusted text: interpolated only,
 * and links only when they are http(s).
 */
@Component({
  selector: 'app-suburb-data-tab',
  templateUrl: './suburb-data-tab.component.html',
  styleUrls: ['./suburb-data-tab.component.scss'],
})
export class SuburbDataTabComponent {
  /** The suburb's detail as the panel has it (suburb-facts.ts detailView). */
  @Input() detail: any;

  readonly safeUrl = safeUrl;
  readonly crawlFacts = crawlFacts;

  constructor(private catalogue: SuburbCatalogueService) {}

  changeText(c: any): string {
    return changeText(
      c,
      (id) => this.catalogue.regionName(id),
      (id) => this.catalogue.subRegionName(id)
    );
  }
}
